import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

/**
 * Create a pick via the server-validated Cloud Function
 */
export async function createPick(gameId, pick) {
  const fn = httpsCallable(functions, 'createPick');
  const result = await fn({ gameId, pick });
  return result.data;
}

/**
 * Cancel the user's active pending pick
 */
export async function cancelPick() {
  const fn = httpsCallable(functions, 'cancelPick');
  const result = await fn();
  return result.data;
}

/**
 * Manually trigger a game sync (for testing/admin)
 */
export async function manualSyncGames() {
  const fn = httpsCallable(functions, 'manualSyncGames');
  const result = await fn();
  return result.data;
}
